import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  dialogModal: {
    '& .MuiPaper-root': {
      paddingLeft: '10px',
      width: '600px !important',
    },
  },
  button: { backgroundColor: '#444', width: '150px', height: '50px', fontSize: '18px' }
}));
export default styles;
